<template>
  <input v-maska="mask" @input="input" type="number" :required="required" :id="id" :value="value" inputmode="numeric"
         class="input-base block w-full sm:leading-5 rounded-md" :class="$parent.inputClass"
         :placeholder="placeholder"/>

</template>

<script>
import maska from './maska/directive'
import {setup, mixin} from "@/components/ui/form/mixins/BaseInput";

export default {
  name: "UiFormNumber",
  setup: setup,
  mixins: [mixin],
  directives: {maska},
  props: {
    mask: {
      default: '#*',
    }
  },
}
</script>
